import Vue from 'vue'
import Vuex from 'vuex'
import channels from './modules/channels'
import search from './modules/search'
import indices from './modules/indices'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    search,
    channels,
    indices
  },
})
